import React from 'react';
import GenericObjectSelector from '../../../components/GenericObjectSelector';
import { useTranslation } from 'react-i18next';
import { Position } from '../../../lib/modelBuilder/constants';
import { CustomPiece } from '../../../lib/modelBuilder/pieces/CustomPiece';
import { CrossPiece } from '../../../lib/modelBuilder/pieces/CrossPiece';

// import styled from 'styled-components';

interface Props {
  title: string;
  inferior: boolean;
  selected: Position | undefined;
  selectedPositionInferior: boolean;
  onSelect: any;
  crossPieces: CustomPiece<CrossPiece>[];
}

const CrossPieceSelector = ({
  title,
  inferior,
  selected,
  selectedPositionInferior,
  onSelect,
  crossPieces,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col ">
      <div className="flex justify-center py-1">{title}</div>
      <div className="flex justify-center items-center">
        <GenericObjectSelector
          title={t('Backside')}
          canAddNew={true}
          present={!!crossPieces.find(e => e.position === Position.Back)}
          selected={
            selectedPositionInferior === inferior && selected === Position.Back
          }
          onClick={() => {
            onSelect(Position.Back, inferior);
          }}
        />
      </div>
      <div className="flex justify-between items-center w-full">
        <GenericObjectSelector
          title={t('Left')}
          canAddNew={true}
          present={!!crossPieces.find(e => e.position === Position.Left)}
          selected={
            selectedPositionInferior === inferior && selected === Position.Left
          }
          onClick={() => {
            onSelect(Position.Left, inferior);
          }}
        />
        <GenericObjectSelector
          title={t('Right')}
          canAddNew={true}
          present={!!crossPieces.find(e => e.position === Position.Right)}
          selected={
            selectedPositionInferior === inferior && selected === Position.Right
          }
          onClick={() => {
            onSelect(Position.Right, inferior);
          }}
        />
      </div>
      <div className="flex justify-center">
        <GenericObjectSelector
          title={t('Front')}
          canAddNew={true}
          present={!!crossPieces.find(e => e.position === Position.Front)}
          selected={
            selectedPositionInferior === inferior && selected === Position.Front
          }
          onClick={() => {
            onSelect(Position.Front, inferior);
          }}
        />
      </div>
    </div>
  );
};

export default CrossPieceSelector;
